import cx from 'classnames';
import { useTranslationWithNamespace } from '@gov-nx/core/service';
import type { PageCode } from '@gov-nx/module/page';
import { useRegistrRidicuContext } from '@gov-nx/module/page';
import { TabsNav } from '@gov-nx/ui/web';

export interface DriversRegistryNavigationProps {
	code: PageCode;
}

export const DriversRegistryNavigation = ({
	code,
}: DriversRegistryNavigationProps) => {
	const { selectedPage, selectPage } = useRegistrRidicuContext();
	const { getLocalizeCurried } = useTranslationWithNamespace();
	const ts = getLocalizeCurried(code);

	return (
		<TabsNav>
			<li className="gov-tabs__item">
				<button
					role="tab"
					className={cx(
						'gov-tabs__btn',
						selectedPage === 'competency' ? 'selected' : ''
					)}
					aria-selected={selectedPage === 'competency'}
					aria-label={`${ts('filtr.wcag.filtrovat')} ${ts(
						'filtr.wcag.opravneni'
					)}`}
					onClick={() => selectPage('competency')}>
					{ts('filtr.opravneni')}
				</button>
			</li>
			<li className="gov-tabs__item">
				<button
					role="tab"
					className={cx(
						'gov-tabs__btn',
						selectedPage === 'offences' ? 'selected' : ''
					)}
					aria-selected={selectedPage === 'offences'}
					aria-label={`${ts('filtr.wcag.filtrovat')} ${ts(
						'filtr.wcag.prestupky'
					)}`}
					onClick={() => selectPage('offences')}>
					{ts('filtr.prestupky')}
				</button>
			</li>
			<li className="gov-tabs__item">
				<button
					role="tab"
					className={cx(
						'gov-tabs__btn',
						selectedPage === 'prohibitions' ? 'selected' : ''
					)}
					aria-selected={selectedPage === 'prohibitions'}
					aria-label={`${ts('filtr.wcag.filtrovat')} ${ts(
						'filtr.wcag.zakazy'
					)}`}
					onClick={() => selectPage('prohibitions')}>
					{ts('filtr.zakazy')}
				</button>
			</li>
		</TabsNav>
	);
};

DriversRegistryNavigation.displayName = 'DriversRegistryNavigation';
